module.exports = __webpack_public_path__ + "img/gb9115_32.prt.71e44f5d.jpg";